<template>
  <div class="growth-dashboard-container">
    <section class="dashboard">
      <div>
        <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      </div>
      <!-- <b-card class="mainCardBG" v-if="globalPermissionStatus('Growth Dashboard') == true"> -->
      <!-- Page Header -->
      <b-row class="mb-4">
        <b-col md="8">
          <div class="d-flex align-items-center">
            <div class="page-icon-wrapper mr-3">
              <i class="fa fa-chart-line page-icon"></i>
            </div>
            <div>
              <h4 class="page-title mb-1">Growth Dashboard</h4>
              <p class="page-subtitle text-muted mb-0">
                <i class="fa fa-calendar-alt mr-2"></i>
                Real-time business analytics & performance insights
              </p>
            </div>
          </div>
        </b-col>
        <b-col md="4" class="text-right">
          <div class="page-actions">
            <b-button variant="outline-primary" class="mr-2" @click="refreshDashboard">
              <i class="fa fa-sync-alt" :class="{ 'fa-spin': isRefreshing }"></i>
              Refresh
            </b-button>
            <b-button variant="primary" @click="exportDashboard">
              <i class="fa fa-download"></i>
              Export
            </b-button>
          </div>
        </b-col>
      </b-row>

      <!-- Summary Cards Row -->
      <!-- <b-row class="mb-4">
      <b-col lg="3" md="6" class="mb-3">
        <b-card class="summary-card h-100 border-0 shadow-sm">
          <div class="d-flex align-items-center">
            <div class="card-icon bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mr-3">
              <i class="fa fa-calendar-alt fa-lg"></i>
            </div>
            <div class="flex-grow-1">
              <h6 class="card-title text-muted mb-1">Current Period</h6>
              <h4 class="mb-0 text-primary">{{ currentPeriod }}</h4>
            </div>
          </div>
        </b-card>
      </b-col>

      <b-col lg="3" md="6" class="mb-3">
        <b-card class="summary-card h-100 border-0 shadow-sm">
          <div class="d-flex align-items-center">
            <div class="card-icon bg-success text-white rounded-circle d-flex align-items-center justify-content-center mr-3">
              <i class="fa fa-trending-up fa-lg"></i>
            </div>
            <div class="flex-grow-1">
              <h6 class="card-title text-muted mb-1">Growth Rate</h6>
              <h4 class="mb-0 text-success">{{ overallGrowthRate }}%</h4>
            </div>
          </div>
        </b-card>
      </b-col>

      <b-col lg="3" md="6" class="mb-3">
        <b-card class="summary-card h-100 border-0 shadow-sm">
          <div class="d-flex align-items-center">
            <div class="card-icon bg-info text-white rounded-circle d-flex align-items-center justify-content-center mr-3">
              <i class="fa fa-users fa-lg"></i>
            </div>
            <div class="flex-grow-1">
              <h6 class="card-title text-muted mb-1">Active Clients</h6>
              <h4 class="mb-0 text-info">{{ activeClients }}</h4>
            </div>
          </div>
        </b-card>
      </b-col>

      <b-col lg="3" md="6" class="mb-3">
        <b-card class="summary-card h-100 border-0 shadow-sm">
          <div class="d-flex align-items-center">
            <div class="card-icon bg-warning text-white rounded-circle d-flex align-items-center justify-content-center mr-3">
              <i class="fa fa-file-invoice-dollar fa-lg"></i>
            </div>
            <div class="flex-grow-1">
              <h6 class="card-title text-muted mb-1">Total Revenue</h6>
              <h4 class="mb-0 text-warning">{{ formatCurrency(totalRevenue) }}</h4>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row> -->

      <!-- Advanced Filters Section -->
      <b-card class="filters-card mb-4" :class="{ 'filters-collapsed': filtersCollapsed }">
        <template #header>
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-center">
              <i class="fa fa-filter text-primary mr-2"></i>
              <h5 class="mb-0">Advanced Filters</h5>
              <b-badge variant="primary" class="ml-2" v-if="activeFiltersCount > 0">
                {{ activeFiltersCount }} active
              </b-badge>
            </div>
            <div class="d-flex align-items-center">
              <b-button variant="outline-primary" size="sm" class="mr-2" @click="toggleFilters">
                <i class="fa" :class="filtersCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
              </b-button>
              <b-button variant="outline-secondary" size="sm" @click="resetFilters">
                <i class="fa fa-undo"></i> Reset
              </b-button>
            </div>
          </div>
        </template>

        <b-collapse :visible="!filtersCollapsed" id="filters-collapse">
          <b-row>
            <!-- Date Filters -->
            <b-col lg="3" md="6">
              <label class="text-muted small">Date Range</label>
              <date-range-picker v-model="dateRange" :startDate="dateRange.startDate" :endDate="dateRange.endDate"
                :opens="'right'" @update="onDateRangeUpdate" class="w-100">
                <template slot="input" slot-scope="picker">
                  <div class="d-flex align-items-center date-range-display">
                    <i class="fa fa-calendar mr-2 text-muted"></i>
                    <span v-if="picker.startDate && picker.endDate">
                      {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{
                        moment(picker.endDate).format('DD/MM/YYYY') }}
                    </span>
                    <span v-else class="text-muted">Select Date Range</span>
                    <i class="fa fa-caret-down ml-auto text-muted"></i>
                  </div>
                </template>
              </date-range-picker>
            </b-col>

            <!-- Entity Filters -->
            <b-col lg="3" md="6">
              <label class="text-muted small">Branch</label>
              <model-list-select :list="$store.getters['common/getAllBranchList']" v-model="filters.branch_id"
                option-value="pickupId" option-text="pickupLocation" placeholder="Select Branch"></model-list-select>
            </b-col>

            <!-- User & Job Filters -->
            <b-col lg="3" md="6">
              <label class="text-muted small">User</label>
              <model-list-select :list="$store.getters['common/getAllUserList']" v-model="filters.user_id"
                option-value="userId" option-text="employeeName" placeholder="Select User"></model-list-select>
            </b-col>
            <b-col lg="3" md="6">
              <label class="text-muted small">Job Type</label>
              <model-list-select :list="jobTypeOptions" v-model="filters.job_type" option-value="value"
                option-text="text" placeholder="Select Job Type"></model-list-select>
            </b-col>

            <!-- Location & Transport Filters -->
            <b-col lg="3" md="6">

              <label class="text-muted small">Shipping Line</label>
              <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                v-model="filters.shipping_line_id" option-value="shippingId" option-text="shippingLine"
                placeholder="Select Shipping Line"></model-list-select>
            </b-col>
            <b-col lg="3" md="6">
              <label class="text-muted small">Transport Type</label>
              <model-list-select :list="transportTypeOptions" v-model="filters.transport_type" option-value="value"
                option-text="text" placeholder="Select Transport Type"></model-list-select>
            </b-col>
          </b-row>

          <!-- Action Buttons Row -->
          <b-row class="mt-3">
            <b-col class="text-right">
              <b-button variant="outline-secondary" class="mr-2" @click="clearFilters">
                <i class="fa fa-times"></i> Clear All
              </b-button>
              <b-button variant="primary" @click="applyFilters" :disabled="isLoading">
                <i class="fa fa-search" :class="{ 'fa-spin': isLoading }"></i>
                Apply Filters
              </b-button>
            </b-col>
          </b-row>
        </b-collapse>
      </b-card>

      <!-- Main Content Tabs -->
      <b-card class="main-content-card">
        <template #header>
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-center">
              <i class="fa fa-chart-bar text-primary mr-2"></i>
              <h5 class="mb-0">Analytics Dashboard</h5>
            </div>
            <div class="tab-indicators">
              <b-badge :variant="activeTab === 'monthly' ? 'primary' : 'light'" class="mr-2">
                Monthly
              </b-badge>

              <b-badge :variant="activeTab === 'branch-wise-monthly' ? 'secondary' : 'light'" class="mr-2">
                Branches Monthly
              </b-badge>
              <b-badge :variant="activeTab === 'branch-wise' ? 'warning' : 'light'" class="mr-2">
                Branches
              </b-badge>
              <b-badge :variant="activeTab === 'assignments' ? 'danger' : 'light'">
                Assignments
              </b-badge>
              <b-badge :variant="activeTab === 'client-wise' ? 'success' : 'light'" class="mr-2">
                Clients
              </b-badge>
              <b-badge :variant="activeTab === 'shipping-line-wise' ? 'info' : 'light'" class="mr-2">
                Shipping
              </b-badge>

            </div>
          </div>
        </template>

        <!-- Custom Tab Navigation -->
        <b-nav pills justified class="custom-tabs mb-3">
          <b-nav-item :active="activeTab === 'monthly'" @click="setActiveTab('monthly')" class="monthly-tab">
            <i class="fa fa-calendar-alt mr-2"></i>
            Monthly Growth
            <b-badge variant="primary" class="ml-2" v-if="monthlyDataCount > 0">
              {{ monthlyDataCount }}
            </b-badge>
          </b-nav-item>
          <b-nav-item :active="activeTab === 'branch-wise-monthly'" @click="setActiveTab('branch-wise-monthly')"
            class="branch-monthly-tab">
            <i class="fa fa-calendar-alt mr-2"></i>
            Branch Monthly
            <b-badge variant="secondary" class="ml-2" v-if="branchMonthlyDataCount > 0">
              {{ branchMonthlyDataCount }}
            </b-badge>
          </b-nav-item>
          <b-nav-item :active="activeTab === 'branch-wise'" @click="setActiveTab('branch-wise')" class="branch-tab">
            <i class="fa fa-building mr-2"></i>
            Branch Performance
            <b-badge variant="warning" class="ml-2" v-if="branchDataCount > 0">
              {{ branchDataCount }}
            </b-badge>
          </b-nav-item>



          <b-nav-item :active="activeTab === 'assignments'" @click="setActiveTab('assignments')"
            class="assignments-tab">
            <i class="fa fa-file-text mr-2"></i>
            Detailed Assignments
            <b-badge variant="danger" class="ml-2" v-if="assignmentsDataCount > 0">
              {{ assignmentsDataCount }}
            </b-badge>
          </b-nav-item>
          <b-nav-item :active="activeTab === 'client-wise'" @click="setActiveTab('client-wise')" class="client-tab">
            <i class="fa fa-users mr-2"></i>
            Client Analysis
            <b-badge variant="success" class="ml-2" v-if="clientDataCount > 0">
              {{ clientDataCount }}
            </b-badge>
          </b-nav-item>

          <b-nav-item :active="activeTab === 'shipping-line-wise'" @click="setActiveTab('shipping-line-wise')"
            class="shipping-tab">
            <i class="fa fa-ship mr-2"></i>
            Shipping Lines
            <b-badge variant="info" class="ml-2" v-if="shippingDataCount > 0">
              {{ shippingDataCount }}
            </b-badge>
          </b-nav-item>


        </b-nav>

        <!-- Tab Content -->
        <div class="tab-content">
          <!-- Monthly Growth Tab -->
          <div class="tab-pane" :class="{ active: activeTab === 'monthly' }" id="monthly">
            <div class="tab-content-wrapper">
              <monthly-growth-component v-if="activeTab === 'monthly'" :filters="filters" :key="'monthly-' + filterKey"
                ref="monthlyTab" @loading="handleLoading"></monthly-growth-component>
            </div>
          </div>

          <!-- Client-wise Tab -->
          <div class="tab-pane" :class="{ active: activeTab === 'client-wise' }" id="client-wise">
            <div class="tab-content-wrapper">
              <client-wise-growth-component v-if="activeTab === 'client-wise'" :filters="filters"
                :key="'client-wise-' + filterKey" ref="clientWiseTab"
                @loading="handleLoading"></client-wise-growth-component>
            </div>
          </div>

          <!-- Shipping Line-wise Tab -->
          <div class="tab-pane" :class="{ active: activeTab === 'shipping-line-wise' }" id="shipping-line-wise">
            <div class="tab-content-wrapper">
              <shipping-line-wise-growth-component v-if="activeTab === 'shipping-line-wise'" :filters="filters"
                :key="'shipping-line-wise-' + filterKey" ref="shippingLineWiseTab"
                @loading="handleLoading"></shipping-line-wise-growth-component>
            </div>
          </div>

          <!-- Branch-wise Tab -->
          <div class="tab-pane" :class="{ active: activeTab === 'branch-wise' }" id="branch-wise">
            <div class="tab-content-wrapper">
              <branch-wise-growth-component v-if="activeTab === 'branch-wise'" :filters="filters"
                :key="'branch-wise-' + filterKey" ref="branchWiseTab"
                @loading="handleLoading"></branch-wise-growth-component>
            </div>
          </div>

          <!-- Branch-wise Monthly Tab -->
          <div class="tab-pane" :class="{ active: activeTab === 'branch-wise-monthly' }" id="branch-wise-monthly">
            <div class="tab-content-wrapper">
              <branch-wise-monthly-growth-component v-if="activeTab === 'branch-wise-monthly'" :filters="filters"
                :key="'branch-wise-monthly-' + filterKey"
                ref="branchWiseMonthlyTab"
                @loading="handleLoading"></branch-wise-monthly-growth-component>
            </div>
          </div>

          <!-- Assignments Tab -->
          <div class="tab-pane" :class="{ active: activeTab === 'assignments' }" id="assignments">
            <div class="tab-content-wrapper">
              <assignments-growth-component v-if="activeTab === 'assignments'" :filters="filters"
                :key="'assignments-' + filterKey" ref="assignmentsTab"
                @loading="handleLoading"></assignments-growth-component>
            </div>
          </div>
        </div>
      </b-card>

      <!-- Footer -->
      <b-card class="footer-card mt-4" body-class="text-center py-3">
        <div class="text-muted small">
          <i class="fa fa-clock mr-1"></i>
          Last updated: {{ lastUpdated }}
          <span class="mx-3">|</span>
          <i class="fa fa-database mr-1"></i>
          Data refreshed every 5 minutes
        </div>
      </b-card>
      <!-- </b-card> -->
    </section>
  </div>
</template>

<script>
import MonthlyGrowthComponent from './growthDashboard/MonthlyGrowthComponent.vue';
import ClientWiseGrowthComponent from './growthDashboard/ClientWiseGrowthComponent.vue';
import ShippingLineWiseGrowthComponent from './growthDashboard/ShippingLineWiseGrowthComponent.vue';
import BranchWiseGrowthComponent from './growthDashboard/BranchWiseGrowthComponent.vue';
import BranchWiseMonthlyGrowthComponent from './growthDashboard/BranchWiseMonthlyGrowthComponent.vue';
import AssignmentsGrowthComponent from './growthDashboard/AssignmentsGrowthComponent.vue';
import CustomLoader from '../common/customLoader.vue';
import GrowthDashboardService from '../../services/GrowthDashboardService.js';
import { globalPermissionStatus, lastVisitPage } from '../../helper/collection.js';
import { ModelListSelect } from "vue-search-select";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";

export default {
  name: 'GrowthDashboard',
  components: {
    MonthlyGrowthComponent,
    ClientWiseGrowthComponent,
    ShippingLineWiseGrowthComponent,
    BranchWiseGrowthComponent,
    BranchWiseMonthlyGrowthComponent,
    AssignmentsGrowthComponent,
    CustomLoader,
    ModelListSelect,
    DateRangePicker
  },
  data() {
    return {
      activeTab: 'monthly',
      filterKey: 0,
      isLoading: false,
      isRefreshing: false,
      filtersCollapsed: false,
      lastUpdated: new Date().toLocaleString(),
      dateRange: {
        startDate: null,
        endDate: null
      },

      // Summary data (dynamic)
      currentPeriod: 'Loading...',
      overallGrowthRate: '0.0',
      activeClients: '0',
      totalRevenue: '₹0',

      // Data counts for badges
      monthlyDataCount: 36,
      clientDataCount: 187,
      shippingDataCount: 45,
      branchDataCount: 23,
      branchMonthlyDataCount: 150,
      assignmentsDataCount: 1247,
      transportTypeOptions: [
        { value: "Export", text: "Export" },
        { value: "Import", text: "Import" }
      ],
      jobTypeOptions: [
        { value: "FF", text: "FF" },
        { value: "CC", text: "CC" },
        { value: "TPT", text: "TPT" },
        { value: "MISC", text: "MISC" },
        { value: "YARD", text: "YARD" },
        { value: "IB", text: "IB" },
      ],

      filters: {
        from_date: null,
        to_date: null,
        year: null,
        client_id: null,
        branch_id: null,
        user_id: null,
        job_no: null,
        job_type: null,
        transport_type: null,
        shipping_line_id: null,
        pod: null,
        pol: null,
        por: null,
        fpod: null
      }
    };
  },

  beforeMount() {
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
        type: 'Normal',
        Territory: '',
      })
    );
    this.$store.dispatch("common/setAllBranchList", JSON.stringify({
      filter: "BranchList",
      active: "all",
    }));
    this.$store.dispatch("common/setAllClientList", JSON.stringify({
      itemCode: "ClientList",
    }));
    this.$store.dispatch("common/setAllShippingLineList", JSON.stringify({
      itemCode: "ShippingLineList",
    }));
    this.$store.dispatch("common/setAllUserList", JSON.stringify({
      itemCode: "GET_USERLIST_Data",
    }));
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/dashboard/growth-dashboard-new"
      );

    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  computed: {
    activeFiltersCount() {
      return Object.values(this.filters).filter(value =>
        value !== null && value !== '' && value !== undefined
      ).length;
    }
  },

  watch: {
    activeTab() {
      // Auto-scroll to top when changing tabs
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  },

  methods: {
    moment(date) {
      return moment(date);
    },
    onDateRangeUpdate() {
      this.filters.from_date = this.dateRange.startDate
        ? moment(this.dateRange.startDate).format("YYYY-MM-DD")
        : null;
      this.filters.to_date = this.dateRange.endDate
        ? moment(this.dateRange.endDate).format("YYYY-MM-DD")
        : null;
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },

    async loadSummaryData() {
      try {
        // Get summary data from monthly growth API
        const monthlyParams = {};
        Object.keys(this.filters).forEach(key => {
          if (this.filters[key] !== null && this.filters[key] !== '') {
            monthlyParams[key] = this.filters[key];
          }
        });

        const monthlyResponse = await GrowthDashboardService.getMonthlyGrowthData(monthlyParams);

        if (monthlyResponse && monthlyResponse.data && monthlyResponse.data.success && monthlyResponse.data.data && monthlyResponse.data.data.summary) {
          const summary = monthlyResponse.data.data.summary;

          // Ensure we have valid numeric values
          const totalInvoices = summary.totalInvoices !== null && summary.totalInvoices !== undefined && !isNaN(summary.totalInvoices)
            ? parseFloat(summary.totalInvoices)
            : 0;

          this.totalRevenue = this.formatCurrency(totalInvoices);

          const profitPercent = summary.overallProfitPercent !== null && summary.overallProfitPercent !== undefined && !isNaN(summary.overallProfitPercent)
            ? parseFloat(summary.overallProfitPercent)
            : 0;

          this.overallGrowthRate = profitPercent.toFixed(1);
        } else {
          this.totalRevenue = '₹0';
          this.overallGrowthRate = '0.0';
        }

        // Get active clients count from client-wise API
        const clientParams = Object.assign({}, monthlyParams);
        const clientResponse = await GrowthDashboardService.getClientWiseGrowthData(clientParams);

        if (clientResponse && clientResponse.data && clientResponse.data.success && clientResponse.data.data && clientResponse.data.data.records) {
          const clientCount = Array.isArray(clientResponse.data.data.records) ? clientResponse.data.data.records.length : 0;
          this.activeClients = clientCount.toLocaleString('en-IN');
        } else {
          this.activeClients = '0';
        }

        // Update current period based on filters
        this.updateCurrentPeriod();

      } catch (error) {
        console.error('Error loading summary data:', error);
        // Set default values on error
        this.totalRevenue = '₹0';
        this.overallGrowthRate = '0.0';
        this.activeClients = '0';
        this.currentPeriod = 'Data unavailable';
        // Show user-friendly error message
        this.$bvToast.toast('Unable to load dashboard summary data. Please try again.', {
          title: 'Data Loading Error',
          variant: 'warning',
          solid: true
        });
      }
    },

    updateCurrentPeriod() {
      // Calculate current period based on filters
      if (this.filters.year) {
        const year = parseInt(this.filters.year);
        if (!isNaN(year)) {
          this.currentPeriod = `Apr ${year} - Mar ${year + 1}`;
        }
      } else {
        // Default to current financial year
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();

        if (currentMonth >= 3) { // April onwards
          this.currentPeriod = `Apr ${currentYear} - Mar ${currentYear + 1}`;
        } else { // January to March
          this.currentPeriod = `Apr ${currentYear - 1} - Mar ${currentYear}`;
        }
      }
    },

    toggleFilters() {
      this.filtersCollapsed = !this.filtersCollapsed;
    },

    async applyFilters() {
      this.isLoading = true;
      try {
        this.filterKey++;
        // Load summary data with new filters
        await this.loadSummaryData();
        this.lastUpdated = new Date().toLocaleString();
        this.$bvToast.toast('Filters applied successfully!', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
      } catch (error) {
        console.error('Error applying filters:', error);
      } finally {
        this.isLoading = false;
      }
    },

    clearFilters() {
      this.filters = {
        from_date: null,
        to_date: null,
        year: null,
        client_id: null,
        branch_id: null,
        user_id: null,
        job_no: null,
        job_type: null,
        transport_type: null,
        shipping_line_id: null,
        pod: null,
        pol: null,
        por: null,
        fpod: null
      };
      this.dateRange = { startDate: null, endDate: null };
      this.filterKey++;
      // Reset summary data
      this.loadSummaryData();
      this.$bvToast.toast('All filters cleared!', {
        title: 'Filters Reset',
        variant: 'info',
        solid: true
      });
    },

    resetFilters() {
      this.clearFilters();
    },

    async refreshDashboard() {
      this.isRefreshing = true;
      try {
        // Reload summary data
        await this.loadSummaryData();
        this.lastUpdated = new Date().toLocaleString();
        this.$bvToast.toast('Dashboard refreshed successfully!', {
          title: 'Refreshed',
          variant: 'success',
          solid: true
        });
      } catch (error) {
        console.error('Error refreshing dashboard:', error);
      } finally {
        this.isRefreshing = false;
      }
    },

    async exportDashboard() {
      const tabRefMap = {
        monthly: 'monthlyTab',
        'branch-wise-monthly': 'branchWiseMonthlyTab',
        'branch-wise': 'branchWiseTab',
        assignments: 'assignmentsTab',
        'client-wise': 'clientWiseTab',
        'shipping-line-wise': 'shippingLineWiseTab'
      };

      const activeRef = tabRefMap[this.activeTab];
      const activeComponent = activeRef ? this.$refs[activeRef] : null;

      if (activeComponent && typeof activeComponent.exportToExcel === 'function') {
        await activeComponent.exportToExcel();
        return;
      }

      this.$bvToast.toast('Export not available for the selected tab.', {
        title: 'Export',
        variant: 'warning',
        solid: true
      });
    },

    handleLoading(loading) {
      this.isLoading = loading;
    },

    formatCurrency(amount) {
      // Handle null, undefined, NaN, or invalid values
      if (amount === null || amount === undefined || isNaN(amount)) {
        return '₹0';
      }

      const numAmount = parseFloat(amount);
      if (isNaN(numAmount)) {
        return '₹0';
      }

      return '₹' + Math.abs(numAmount).toLocaleString('en-IN');
    }
  },

  async mounted() {
    // Set default economic year
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    // If it's before April, use previous year as start
    if (currentDate.getMonth() < 3) { // 0 = January, 3 = April
      this.filters.year = currentYear - 1;
    } else {
      this.filters.year = currentYear;
    }
    const startYear = this.filters.year;
    this.dateRange.startDate = new Date(startYear, 3, 1);
    this.dateRange.endDate = new Date(startYear + 1, 2, 31);
    this.onDateRangeUpdate();

    // Load initial summary data
    await this.loadSummaryData();

    // Update last updated time
    setInterval(() => {
      this.lastUpdated = new Date().toLocaleString();
    }, 60000); // Update every minute
  }
};
</script>

<style scoped>
.growth-dashboard-container {
  padding: 20px;
}

/* Page Header */
.page-icon-wrapper {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.page-icon {
  font-size: 20px;
}

.page-title {
  color: #495057;
  font-weight: 600;
  font-size: 1.5rem;
  margin-bottom: 0;
}

.page-subtitle {
  font-size: 0.85rem;
}

.page-actions .btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.page-actions .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
}

/* Summary Cards */
.summary-card {
  border-radius: 8px;
  transition: all 0.3s ease;
  background: white;
  border: 1px solid #dee2e6;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-icon {
  width: 45px;
  height: 45px;
  transition: all 0.3s ease;
}

.summary-card:hover .card-icon {
  transform: scale(1.05);
}

.card-title {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* Filters Section */
.filters-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.filters-card:not(.filters-collapsed) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.filter-group {
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: #f8f9fa;
  transition: all 0.3s ease;
  overflow: visible;
}

.filter-group:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}

.filter-group .card-header {
  background: transparent;
  border-bottom: none;
  padding: 15px 20px 10px;
  font-weight: 600;
  color: #495057;
}

.filter-group .card-body {
  padding: 15px 20px 20px;
}

/* Form Controls */
.form-control-sm {
  border-radius: 8px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
  font-size: 0.875rem;
}

.form-control-sm:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  transform: translateY(-1px);
}

/* Date Range Picker: prevent double input UI */
::v-deep .vue-daterange-picker {
  width: 100% !important;
}

::v-deep .vue-daterange-picker .form-control {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  box-shadow: none;
}

::v-deep .vue-daterange-picker .reportrange-text {
  border: none !important;
  background: transparent !important;
  padding: 0 !important;
  width: 100%;
}

.date-range-display {
  width: 100%;
  font-size: 0.875rem;
  line-height: 1.5;
}

/* Prevent picker/select overlap clipping in filter grid */
.filters-card,
.filters-card ::v-deep .card-body,
.filters-card ::v-deep .row,
.filters-card ::v-deep [class*="col-"],
.filter-group,
.filter-group ::v-deep .card-body {
  overflow: visible !important;
}

::v-deep .daterangepicker {
  z-index: 4000 !important;
}

/* vue-search-select dropdown menu classes */
::v-deep .options,
::v-deep .menu,
::v-deep .v-select-list {
  z-index: 4000 !important;
}

.border-primary {
  border-color: #007bff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.1);
}

.border-success {
  border-color: #28a745 !important;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.1);
}

.border-info {
  border-color: #17a2b8 !important;
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.1);
}

.border-warning {
  border-color: #ffc107 !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.1);
}

/* Main Content Card */
.main-content-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.main-content-card .card-header {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 15px 20px;
}

/* Custom Tabs */
.custom-tabs {
  border: none;
  background: rgba(248, 249, 250, 0.5);
  border-radius: 10px;
  padding: 5px;
}

.custom-tabs .nav-pills .nav-link {
  border-radius: 25px;
  padding: 12px 20px;
  margin: 0 2px;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  background: transparent;
  color: #6c757d;
}

.custom-tabs .nav-pills .nav-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 0.8);
}

.custom-tabs .nav-pills .nav-link.active {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border-color: #007bff;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.monthly-tab.active {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
}

.client-tab.active {
  background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%) !important;
}

.shipping-tab.active {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%) !important;
}

.branch-tab.active {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%) !important;
}

.assignments-tab.active {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
}

.branch-monthly-tab.active {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%) !important;
}

/* Tab Content */
.tab-content {
  border: none;
}

.tab-pane {
  display: none;
}

.tab-pane.active {
  display: block;
}

.tab-content-wrapper {
  padding: 25px;
  background: white;
  min-height: 600px;
  border-radius: 0 0 12px 12px;
}

/* Tab Indicators */
.tab-indicators .badge {
  font-size: 0.75rem;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 600;
}

/* Footer */
.footer-card {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #f8f9fa;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.summary-card {
  animation: fadeInUp 0.6s ease-out;
}

.summary-card:nth-child(1) {
  animation-delay: 0.1s;
}

.summary-card:nth-child(2) {
  animation-delay: 0.2s;
}

.summary-card:nth-child(3) {
  animation-delay: 0.3s;
}

.summary-card:nth-child(4) {
  animation-delay: 0.4s;
}

/* Responsive Design */
@media (max-width: 768px) {
  .growth-dashboard-container {
    padding: 15px;
  }

  .page-icon-wrapper {
    width: 45px;
    height: 45px;
  }

  .page-icon {
    font-size: 18px;
  }

  .page-title {
    font-size: 1.3rem;
  }

  .tab-content-wrapper {
    padding: 15px;
  }

  .summary-card {
    margin-bottom: 15px;
  }

  .filter-group {
    margin-bottom: 15px;
  }
}

@media (max-width: 576px) {
  .page-actions {
    flex-direction: column;
    gap: 8px;
    margin-top: 15px;
  }

  .page-actions .btn {
    width: 100%;
  }

  .tab-indicators {
    display: none;
  }

  .custom-tabs .nav-pills .nav-link {
    padding: 8px 15px;
    margin: 2px;
    font-size: 0.85rem;
  }
}

/* Loading States */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Custom Scrollbar */
.custom-tabs ::-webkit-scrollbar {
  height: 6px;
}

.custom-tabs ::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.custom-tabs ::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.custom-tabs ::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Utility Classes */
.text-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
</style>



// WEBPACK FOOTER //
// growthDashboard.vue?e6ffeb16